const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;
export const DRAFT_TTL = ONE_DAY_IN_MS;